/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateSessionJanus} from '../api'

export const useMutationInitiateSessionJanus = createReactQueryMutationHook('initiateSessionJanus', initiateSessionJanus)
